export default "__VITE_ASSET__B_aOWiJ6__"